
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { TestEquipmentDevice, TestEquipmentTest } from '../../../backend/backendapi';
import TestEquipmentEdit from './TestEquipmentEdit';
import State from '../State';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    TestEquipmentEdit,
  },
})
export default class TestEquipmentEditModal extends Vue {
  @Prop({ default: true })
  readonly editable!: boolean;
  @Prop({ default: true })
  readonly showArchiveFields!: boolean;

  @Inject({ from: 'state' })
  readonly state!: State;

  equipment: TestEquipmentDevice | null = null;
  tests: TestEquipmentTest[] | null = null;

  get canSave(): boolean {
    return this.equipment.placeOfUseShortId > 0
        && this.equipment.groupId > 0
        && this.equipment.kindId > 0
        && !!this.equipment.name
        && !!this.equipment.issueDate
        && this.equipment.intervalValue >= 0
        && this.equipment.intervalUnitId > 0
        && this.equipment.warningValue >= 0
        && this.equipment.warningUnitId > 0
        && !!this.equipment.placeOfUse
        && !!this.equipment.responsible
        && !!this.equipment.deviceManufacturer
        && !!this.equipment.deviceType
        && !!this.equipment.deviceSerialNumber
        && !!this.equipment.testSpecification
        && !!this.equipment.testProcedure
        && !!this.equipment.responsible;
  }

  public open(equipment: TestEquipmentDevice, tests: TestEquipmentTest[] | null): void {
    this.equipment = equipment;
    this.tests = tests;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.equipment = null;
    this.tests = null;
    $(this.$refs.modal!).modal('hide');
  }

  save(): void {
    this.$emit('save', this.equipment);
  }
}
